var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Contatos")]),_c('Contatos',{model:{value:(_vm.user.pessoa_fisica.contatos),callback:function ($$v) {_vm.$set(_vm.user.pessoa_fisica, "contatos", $$v)},expression:"user.pessoa_fisica.contatos"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }